export default function GlobalModal() {
  const globalModals = document.querySelectorAll(".js-global-modal-block");

  if (globalModals && globalModals.length > 0) {
    globalModals.forEach((item) => {
      const openBtn = item.querySelectorAll<HTMLButtonElement>(".js-open-modal-btn");
      const closeBtn = item.querySelector<HTMLButtonElement>(".js-close-modal-btn");
      const trapFocusBtn = item.querySelector<HTMLButtonElement>(".js-trap-focus-btn");
      const wrapper = item.querySelector<HTMLDivElement>(".js-modal-wrapper");
      const modal = item.querySelector<HTMLDivElement>(".js-modal");

      if (openBtn && closeBtn && trapFocusBtn && wrapper && modal) {
        const handleClickOutside = (e: MouseEvent) => {
          const target = e.target as HTMLElement;

          if (target.classList.contains("js-modal-wrapper")) {
            closeModal();
          }
        };

        const handleEscape = (e: KeyboardEvent) => {
          if (e.key === "Escape") {
            closeModal();
          }
        };

        const handleTabIndex = (isFocus: boolean) => {
          const focusableSelectors = `
                a[href],
                area[href],
                input:not([disabled]),
                select:not([disabled]),
                textarea:not([disabled]),
                button:not([disabled]),
                iframe,
                object,
                embed
            `;

          const focusItems = modal.querySelectorAll<HTMLElement>(focusableSelectors);

          focusItems.forEach((item) => {
            if (isFocus) {
              item.tabIndex = 0;
            } else {
              item.tabIndex = -1;
            }
          });
        };

        const handleResetIframe = () => {
          const iframe = item.querySelector<HTMLIFrameElement>("iframe");
          // resets and stops iframe from playing on close
          if (iframe) {
            iframe.src = "";
          }
        };

        const handleIframeSrc = (id: string, title: string) => {
          const iframe = item.querySelector<HTMLIFrameElement>("iframe");
          // resets and stops iframe from playing on close
          if (iframe) {
            iframe.src = `//play.vidyard.com/${id}.html?`;
            if (title) {
              iframe.title = title;
            }
          }
        };

        const openModal = () => {
          wrapper.setAttribute("aria-hidden", "false");
          wrapper.setAttribute("data-isOpen", "true");
          handleTabIndex(true);
          document.addEventListener("keydown", handleEscape);
        };

        const closeModal = () => {
          wrapper.setAttribute("aria-hidden", "true");
          wrapper.setAttribute("data-isOpen", "false");
          handleTabIndex(false);
          handleResetIframe();
          document.removeEventListener("keydown", handleEscape);
        };

        const handleResetFocus = () => {
          // taps focus and resets to first item
          closeBtn.focus();
        };

        // handle cms content and update tab index on load to -1
        handleTabIndex(false);

        document.addEventListener("click", handleClickOutside);

        openBtn.forEach((btn) => {
          btn.addEventListener("click", () => {
            const id = btn.getAttribute("data-videoId");
            const title = btn.getAttribute("data-videoTitle") || "";

            if (id) {
              handleIframeSrc(id, title);
            }
            openModal();
          });
        });

        closeBtn.addEventListener("click", () => {
          closeModal();
        });

        trapFocusBtn.addEventListener("focus", handleResetFocus);
      }
    });
  }
}
